import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentAuthUser, subscribeToAuthChanges } from "../services/authDataService";

const GateIcon = ({ className = "login-icon" }) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    let unsubscribeRef = null;
    let mounted = true;

    const init = async () => {
      try {
        const user = await getCurrentAuthUser();
        if (mounted) {
          setIsLoggedIn(!!user?.uid);
        }

        unsubscribeRef = await subscribeToAuthChanges((nextUser) => {
          if (!mounted) return;
          setIsLoggedIn(!!nextUser?.uid);
        });
      } catch (error) {
        console.warn("GateIcon auth state failed:", error);
        if (mounted) setIsLoggedIn(false);
      }
    };

    init();

    return () => {
      mounted = false;
      if (typeof unsubscribeRef === "function") {
        const maybePromise = unsubscribeRef();
        if (maybePromise?.catch) {
          maybePromise.catch((err) =>
            console.warn("GateIcon unsubscribe failed:", err)
          );
        }
      }
    };
  }, []);

  const handleClick = () => {
    navigate(isLoggedIn ? "/profil" : "/login");
  };

 return (
  <img
    src="/gate-icon.png"
    alt="Profil / Login"
    className={className}
    onClick={handleClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleClick();
      }
    }}
  />
);
};

export default GateIcon;